module.exports = __webpack_public_path__ + "img/teacher4.69fd60ae.webp";